import { useEffect } from 'react';
import Raven from 'raven-js';

// @ts-expect-error Untyped dependency
import { setupCes } from 'wootric-nps/ces/ces-setup';
const SurveyKey = {
  CES: 'ACADEMY'
};
const useWootricSurvey = (surveyType, skip) => {
  useEffect(() => {
    try {
      if (skip) return;
      if (surveyType === 'CES') {
        setupCes(SurveyKey[surveyType]);
        return;
      }
      return;
    } catch (error) {
      Raven.captureException(error, {
        extra: {
          from: 'triggerWootricSurvey',
          surveyType,
          surveyKey: SurveyKey[surveyType]
        }
      });
    }
  }, [skip, surveyType]);
};
export default useWootricSurvey;